module.exports = __webpack_public_path__ + "img/coupon-icon-01.0537b3d0.png";